




























































































































import BaseComponent from '@/components/base-component.vue';
import { IdNomeDTO } from '@/interfaces/base-dto';
import {
  MedidasProdutosEnteralCalcParm,
  MedidasProdutosEnteralResult,
  UnidadeMedidaProdCalcParm
} from '@/interfaces/product';
import * as service from '@/services/prescription';
import { PrescriptionValidation } from '@/settings/consts/prescription-validation';
import Component from 'vue-class-component';
import { CurrencyDirective, parseCurrency } from 'vue-currency-input';
import { Prop, Watch } from 'vue-property-decorator';
import PrescriptionEnteralDetails from '../prescription-enteral-details.vue';

@Component({
  components: {
    PrescriptionEnteralDetails,
  },
  directives: {
    currency: CurrencyDirective,
  },
})
export default class PrescriptionFormEnteral extends BaseComponent {
  @Prop()
  public item: any;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public prescriptionState: any;

  private enterals: IdNomeDTO[] = [];
  private loading: boolean = false;
  private error: boolean = false;
  private configsAlteravel: boolean = true;
  private tipoCalculo: IdNomeDTO;

  private dto: DadosEnteralDTO = new DadosEnteralDTO();
  private result: MedidasProdutosEnteralResult = null;
  private detailOpen: boolean = false;
  private quantidadeEnteralFmt: string = null;

  public rules: any = {
    quantidadeEnteral: [(v) => !this.dto.idEnteral || !!v || 'Informe a quantidade'],
    objetivoCalorico: [(v) => !this.dto.idEnteral || !!v || 'Informe o objetivo calórico'],
    fatorTermogenese: [(v) => !this.dto.idEnteral || !!v || 'Informe o fator de termogênese'],
    fatorSuspensao: [(v) => !this.dto.idEnteral || !!v || 'Informe o fator de Suspensão'],
  };

  mask2dec = {
    currency: { prefix: '', suffix: '' },
    locale: 'pt-BR',
    precision: { min: 0, max: 2 },
  };

  @Watch('item')
  private onChangeItem(): void {
    this.limpar();
    if (this.item.enteral) {
      this.dto.idEnteral = this.item.enteral.idEnteral;
      this.dto.qtdeEnteralMl = this.item.enteral.quantidadeEnteral;
      if (this.item.enteral.quantidadeEnteral) {
        this.quantidadeEnteralFmt = this.decimalFormatHelper(this.item.enteral.quantidadeEnteral);
      }
    }
  }

  @Watch('item.paciente')
  private onChangePaciente(): void {
    this.limpar();
    this.loadEnterals();
  }

  @Watch('item.medico')
  private onChangeMedico(): void {
    this.limpar();
    this.loadEnterals();
  }

  @Watch('item.unidade')
  private onChangeClientUnit(): void {
    this.limpar();
    this.loadEnterals();
  }

  @Watch('item.terapia')
  private onChangeTerapia(): void {
    this.limpar();
    this.loadEnterals();
  }

  @Watch('item.tipoPrescricao')
  private onChangeTipoPrescricao(): void {
    this.limpar();
    this.loadEnterals();
  }

  private onChangeEnteral() {
    this.removerCalculo();
  }

  timeoutAviso = null;
  private removerCalculo() {
    if (this.result) {
      if (this.timeoutAviso) {
        clearTimeout(this.timeoutAviso);
      }
      this.timeoutAviso = setTimeout(() => {
        if (this.item.paciente && this.item.paciente.id) {
          let msg =
            'O desconto enteral foi removido. Para aplicar novamente, preencha os dados correspondentes e clique no botão calcular.';
          this.dialog.show('alert', 'Desconto Enteral removido!', msg, 'OK', null, null, null, null, '400px');
        }
      }, 500);
      this.result = null;
      this.$emit('change', null);
    }
  }

  private calcular() {
    this.calcularEnteral();
  }

  private limpar() {
    this.dto.idEnteral = null;
    this.dto.qtdeEnteralMl = null;
    this.dto.volumeDemaisFluidosMl = null;
    this.removerCalculo();
  }

  private loadEnterals() {
    if (
      this.item.isVisualization() ||
      !this.item.paciente ||
      !this.item.paciente.id ||
      !this.item.unidade ||
      !this.item.unidade.id ||
      !this.item.medico ||
      !this.item.medico.id
    ) {
      this.enterals = [];
      this.dto = new DadosEnteralDTO();
      return;
    }

    this.dto = new DadosEnteralDTO();
    this.onChangeEnteral();

    this.item.concordoEnteral = false;
    this.error = false;
    this.loading = true;
    let idTerapia = this.item.terapia ? this.item.terapia.id : null;
    let idMedico = this.item.medico.id;
    service.getEnteralsAvailable(this.item.unidade.id, this.item.paciente.id, idTerapia, idMedico).subscribe(
      (result) => {
        this.enterals = result.enterais;
        this.dto.objetivoCalorico = result.objetivoCalorico;
        this.dto.fatorTermogenese = result.fatorTermogenese;
        this.dto.fatorSuspensao = result.fatorSuspensao;
        this.dto.volumeDemaisFluidosMl = null;
        this.tipoCalculo = result.tipoCalculo;
        this.configsAlteravel = result.permiteAlterarConfigs;
        this.loading = false;
      },
      (error) => {
        this.error = true;
        this.loading = false;
      },
    );
  }

  private isEnteralVisivel() {
    return (
      (this.item && this.item.isVisualization() && this.item.enteral && this.item.enteral.idEnteral) ||
      (this.enterals && this.enterals.length)
    );
  }

  private showConcordo(): boolean {
    return !this.disabled && !!this.dto.idEnteral && !!this.dto.qtdeEnteralMl;
  }

  private configsDisabled(): boolean {
    return this.disabled || !this.dto.idEnteral || !this.configsAlteravel;
  }

  private calcularEnteral() {
    if (!this.dto || !this.dto.isCompleto()) {
      return;
    }

    let payload: MedidasProdutosEnteralCalcParm = new MedidasProdutosEnteralCalcParm();
    let p = this.item;
    payload.idUnidCliente = p.unidade.id;
    payload.idPaciente = p.paciente.id;
    payload.pesoPaciente = Number(p.paciente.peso);
    payload.usoPesoCalorico = p.usoPesoCalorico;
    payload.volumeBolsaMl = Number(p.volumeDesejado);
    payload.volumeDemaisFluidosMl = this.dto.volumeDemaisFluidosMl
      ? parseCurrency(this.dto.volumeDemaisFluidosMl.toString(), this.mask2dec)
      : null;
    payload.tempoInfusao = p.tempoInfusao;
    payload.idEnteral = this.dto.idEnteral;
    payload.qtdeEnteralMl = this.dto.qtdeEnteralMl
      ? parseCurrency(this.dto.qtdeEnteralMl.toString(), this.mask2dec)
      : null;
    payload.objetivoCalorico = this.dto.objetivoCalorico;
    payload.fatorTermogenese = this.dto.fatorTermogenese;
    payload.fatorSuspensao = this.dto.fatorSuspensao;
    payload.idTerapia = this.item.terapia ? this.item.terapia.id : null;
    let produtos: UnidadeMedidaProdCalcParm[] = [];
    payload.produtos = produtos;
    p.produtos.forEach((prod) => {
      let prodParm: UnidadeMedidaProdCalcParm = new UnidadeMedidaProdCalcParm();
      prodParm.idProduto = prod.idProduto;
      let unidadeMedida = prod.unidadeMedidasProduto.filter((um) => um.digitado)[0];
      prodParm.idUnidadeMedida = unidadeMedida.id;
      prodParm.valor = unidadeMedida.valor;
      produtos.push(prodParm);
    });

    this.loader.start('Calculando Enteral...');
    service.calcMultiUnitsEnteralConversion(payload).subscribe(
      (result) => {
        this.result = result;
        this.tipoCalculo = result.tipoCalculo;
        this.loader.stop();
        setTimeout(() => {
          if (result.suspender) {
            this.$emit('change', null);
          } else {
            this.$emit('change', Object.assign(new MedidasProdutosEnteralResult(), this.result));
          }
        }, 100);
      },
      (error) => {
        this.loader.stop();
        this.toast.show(error.data.message.replace(/\n/g, '</br>'), 'error', true);
      },
    );
  }

  private detalhar() {
    this.detailOpen = true;
  }

  private closeDetalhes() {
    this.detailOpen = false;
  }

  public isLoading(): boolean {
    return this.prescriptionState === PrescriptionValidation.LOADING.key;
  }
}

export class DadosEnteralDTO extends MedidasProdutosEnteralCalcParm {
  public isCompleto(): boolean {
    return (
      !!this.idEnteral &&
      !!this.qtdeEnteralMl &&
      !!this.objetivoCalorico &&
      !!this.fatorTermogenese &&
      !!this.fatorSuspensao
    );
  }
}
